import { useEffect } from "react";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { Layout } from "@components/Layout/index";
import { getIndexPage, getModalSettings, getGlobalConfig } from "@lib/api/calls";
import { Render } from "@components/sections";
import { trackEvent } from "@lib/track-event";
import styles from "./About.module.css";

export default function About({ preview, title, content, seo, config, subscribed, modal }) {
  useEffect(() => {
    trackEvent("view_page", {
      pageTitle: title,
      pageCategory: "Information Page",
      pageLocation: window.location.href,
      pagePath: window.location.pathname,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout
      config={config}
      title={title}
      seo={seo}
      subscribed={subscribed}
      isPreview={preview}
      modal={modal}
      pageFound={true}
    >
      <main className={styles.container}>{content && <Render sections={content} />}</main>
    </Layout>
  );
}

export async function getStaticProps({ preview = false, locale }) {
  const aboutPage = await getIndexPage(preview, locale, "about-index");
  const modal = await getModalSettings(locale, preview);
  const config = await getGlobalConfig(locale, preview);

  const seo = {
    seoTitle: "Kotn · For Lasting Ways of Life",
    seoDescription: aboutPage?.meta?.seoDescription || "",
    openGraphImage: aboutPage?.meta?.openGraphImage || null,
    twitterCard: aboutPage?.meta?.seoTwitterCardStyle || "summary_large_image",
  };

  return {
    props: {
      preview,
      title: "Kotn · For Lasting Ways of Life",
      seo,
      content: aboutPage?.blocks || null,
      modal,
      config,
      ...(await serverSideTranslations(locale, ["common", "navbar", "footer", "cart"])),
    },
    revalidate: 1800,
  };
}
